module.exports = __webpack_public_path__ + "img/freeSupport.0a61868.svg";